/* ========================================
   Accordion Stack Rich 2026 - Interactive Logic
   ======================================== */

(function() {
  'use strict';

  class AccordionStackRich {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll('[data-accordion-item]'));
      this.handleResize = this.refreshHeights.bind(this);
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      this.items.forEach((item) => {
        const content = item.querySelector('[data-accordion-content]');

        if (content) {
          content.addEventListener('click', (e) => this.handleContentClick(e));
          content.addEventListener('keydown', (e) => this.handleContentKeydown(e));
        }
      });

      this.collapseAll();

      this.bindImageLoadAdjustments();
      window.addEventListener('resize', this.handleResize);
    }

    handleContentClick(e) {
      e.preventDefault();
      this.toggleAll();
    }

    handleContentKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      this.toggleAll();
    }

    getCollapsedHeight(content) {
      var bgImage = content.querySelector('.accordion-stack-rich-2026__content-bg-image');
      if (bgImage && bgImage.complete && bgImage.naturalHeight > 0) {
        return bgImage.offsetHeight + 'px';
      }
      return getComputedStyle(this.section).getPropertyValue('--collapsed-height').trim() || '180px';
    }

    expandItem(item) {
      if (!item) return;

      const content = item.querySelector('[data-accordion-content]');

      item.classList.add('is-expanded');
      if (content) {
        content.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    collapseItem(item) {
      if (!item) return;

      const content = item.querySelector('[data-accordion-content]');

      item.classList.remove('is-expanded');
      if (content) {
        content.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = this.getCollapsedHeight(content);
      }
    }

    collapseAll() {
      var self = this;
      this.items.forEach((item) => {
        item.classList.remove('is-expanded');

        const content = item.querySelector('[data-accordion-content]');
        if (content) {
          content.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = self.getCollapsedHeight(content);
        }
      });

      this.section.classList.remove('is-expanded-all');
    }

    expandAll() {
      this.items.forEach((item) => this.expandItem(item));
      this.section.classList.add('is-expanded-all');
    }


    allExpanded() {
      if (this.items.length === 0) return false;
      return this.items.every((item) => item.classList.contains('is-expanded'));
    }

    toggleAll() {
      if (this.allExpanded()) {
        this.collapseAll();
      } else {
        this.expandAll();
      }
    }

    refreshHeights() {
      var self = this;
      this.items.forEach((item) => {
        const content = item.querySelector('[data-accordion-content]');
        if (!content) return;

        if (item.classList.contains('is-expanded')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = self.getCollapsedHeight(content);
        }
      });
    }

    bindImageLoadAdjustments() {
      var self = this;
      const images = this.section.querySelectorAll('.accordion-stack-rich-2026__content img');
      images.forEach((img) => {
        img.addEventListener('load', function() {
          self.refreshHeights();
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.accordion-stack-rich-2026');
    sections.forEach((section) => {
      new AccordionStackRich(section);
    });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = e.detail.target;
      if (section && section.classList.contains('accordion-stack-rich-2026')) {
        new AccordionStackRich(section);
      }
    });
  }
})();